/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PolarisProductGlobalFieldsSettingsEntrypointProps } from './polarisProductGlobalFieldsSettings.entrypoint.types.tsx';

type PolarisProductGlobalFieldsSettingsEntryPointComponent = EntryPointComponent<
	{},
	{},
	PolarisProductGlobalFieldsSettingsEntrypointProps,
	{} | null
>;

export const polarisProductGlobalFieldsSettingsEntryPoint: EntryPoint<
	PolarisProductGlobalFieldsSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<PolarisProductGlobalFieldsSettingsEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-global-fields", jiraSpaEntry: "async-polaris-ideas" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
